import { useNavigate } from "react-router-dom";
import NavLayout from "../../layout/Navigation/NavLayout";
import SpaceShooterGame from '@robotical/space-shooter-game/dist/App';
import { createElement, useEffect, useLayoutEffect } from "react";
import EmojiModal from "../../components/modals/EmojiModal";
import { emojiFeedbackModalState } from "../../state-observables/modal/ModalState";
import { useConnectedRafts } from "../../store/SelectedRaftContext";
import { RaftTypeE } from "../../types/raft";
import CarouselNavigation from "../../components/disposables/CarouselNavigation";
import { VisitedScreenEnum } from "@robotical/appv2-analytics-gatherer/dist/types/types";

function SpaceShooterGameScreen() {
  const navigate = useNavigate();
  const { connectedRafts } = useConnectedRafts();
  const isAnyCogConnected = connectedRafts.find(connectedRaft => connectedRaft.isSelected && connectedRaft.type === RaftTypeE.COG);

  useLayoutEffect(() => {
    if (!isAnyCogConnected) {
      window.applicationManager.toaster.info("Please connect to a Cog first to enter this activity.");
      setTimeout(() => {
        navigate("/games");
      }, 200);
    }
  }, [navigate]);

  useEffect(() => {
    let stopHeartbeat: (() => void) | null = null;
    const logVisit = async () => {
      // stopHeartbeat = await window.applicationManager.AnalyticsFacade.logScreenVisit(VisitedScreenEnum.SPACE_SHOOTER_GAME);
      // @ts-ignore :TODO add SPACE_SHOOTER_GAME to analytics-gatherer
      stopHeartbeat = await window.applicationManager.AnalyticsFacade.logScreenVisit('space-shooter-game');
    };
    logVisit();

    return () => {
      if (stopHeartbeat) {
        // stopHeartbeat();
      }
    };
  }, []);

  useEffect(() => {
    window.applicationManager.returnToMainApp = () => {
      const shouldExit = window.confirm("Are you sure you want to exit and return to the main app?");
      if (shouldExit) {
        navigate("/games");
      }
    }
  }, []);

  const clickBackHandler = () => {
    navigate("/games");
    const ModalComponent = createElement(EmojiModal, { otherInfoObject: { page: "space-shooter-game" } });
    emojiFeedbackModalState.setModal(ModalComponent, "");
    emojiFeedbackModalState.updateModalProps({ withCloseButton: true });
  };

  return (
    <NavLayout onClickBack={clickBackHandler}>
      <SpaceShooterGame />
      <CarouselNavigation navigatorName="games" />
    </NavLayout>
  );
}

export default SpaceShooterGameScreen;
